<template>
  <div v-for="(container, containerIndex) in inputItems" class="d-flex flex-column" :key="containerIndex">
    <div class="d-flex justify-space-between w-100 align-start mb-3">
      <div class="d-flex ga-4 w-100 align-center">
        <div v-for="(_, inputIndex) in Array(props.inputCount).fill(0)" :key="inputIndex" class="input-container"
          :style="`width: ${calculateInputWidth(inputIndex)}; padding-right: 8px;`">
          <rb-input v-model="container[inputIndex]" :counter="props.maxLength[inputIndex] ? true : false"
            :maxlength="props.maxLength[inputIndex] || undefined" :label="props.label[inputIndex]"
            :append-inner-icon="props.icons[inputIndex]" :rules="getRules(inputIndex)"
            :error-messages="customErrorMessages(container, containerIndex, inputIndex)">
          </rb-input>
        </div>
      </div>
      <v-btn rounded="xl" class="mt-1 px-6 py-5 d-flex" variant="text" @click="removeInput(containerIndex)" :icon="'mdi-minus'"
        v-tooltip="'Remover item'"></v-btn>
    </div>
  </div>

  <v-divider class="w-100"></v-divider>
  <v-btn class="multivalued-add-button px-6 py-5 d-flex rounded-pill " prepend-icon="mdi-plus" variant="text" @click="addInput" color="primary-35">
    {{ props.addText }}
  </v-btn>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits } from 'vue';
const inputItems = ref([]);
const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  inputCount: { type: Number, default: 1 },
  label: { type: Array, default: () => ['Campo multivalorado'] },
  disposition: { type: Array, default: () => [1] },
  icons: { type: Array, default: () => [] },
  maxLength: { type: Array, default: () => [] },
  addText: { type: String, default: 'Adicionar item' },
  rules: { type: Array, default: () => [] },
  specificRules: { type: Object, default: () => ({}) },
  customErrorConditions: {
    type: Object,
    default: () => ({})
  },
  customErrorMessages: {
    type: Object,
    default: () => ({})
  }
});

const addInput = () => {
  const newItem = Array(props.inputCount).fill('');
  inputItems.value.push(newItem);
  emit('update:modelValue', inputItems.value);
};

const removeInput = (index) => {
  inputItems.value.splice(index, 1);
  emit('update:modelValue', inputItems.value);
};

const calculateInputWidth = (inputIndex) => {
  if (typeof props.disposition[inputIndex] === 'string' && props.disposition[inputIndex].includes('px')) {
    return props.disposition[inputIndex];
  }
  const totalProportion = props.disposition.reduce((sum, value) => {
    return sum + value;
  }, 0);

  const proportion = props.disposition[inputIndex] / totalProportion;
  return `${proportion * 100}%`;
};

const getRules = (inputIndex) => {
  const rules = [];
  if (props.rules && props.rules.length) {
    rules.push(...props.rules);
  }
  if (props.specificRules && props.specificRules[inputIndex]) {
    rules.push(...props.specificRules[inputIndex]);
  }

  return rules;
};

const customErrorMessages = (container, containerIndex, inputIndex) => {
  if (!validateError(container, containerIndex, inputIndex)) {
    return null;
  }
  if (props.customErrorMessages && props.customErrorMessages[inputIndex]) {
    const message = props.customErrorMessages[inputIndex];
    return message;
  }
  return null;
};

const validateError = (container, containerIndex, inputIndex) => {
  if (props.customErrorConditions && props.customErrorConditions[inputIndex]) {
    return props.customErrorConditions[inputIndex](container, containerIndex, inputItems.value);
  }
  return false;
};


onMounted(() => {
  if (props.modelValue && props.modelValue.length > 0) {
    return inputItems.value = props.modelValue;
  }
  addInput();
});
</script>

<style scoped>
.input-container {
  position: relative;
  display: flex;
  flex-direction: column;
}

.multivalued-add-button {
  width: fit-content !important;
}
</style>